/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityAssetDomainBlocklist
 */
export interface MonitEntityAssetDomainBlocklist {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    root_domain?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    source_list_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    subcategory?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    created?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityAssetDomainBlocklist
     */
    last_found?: number;
}

/**
 * Check if a given object implements the MonitEntityAssetDomainBlocklist interface.
 */
export function instanceOfMonitEntityAssetDomainBlocklist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityAssetDomainBlocklistFromJSON(json: any): MonitEntityAssetDomainBlocklist {
    return MonitEntityAssetDomainBlocklistFromJSONTyped(json, false);
}

export function MonitEntityAssetDomainBlocklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityAssetDomainBlocklist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'root_domain': !exists(json, 'root_domain') ? undefined : json['root_domain'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'source_list_name': !exists(json, 'source_list_name') ? undefined : json['source_list_name'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'subcategory': !exists(json, 'subcategory') ? undefined : json['subcategory'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'last_found': !exists(json, 'last_found') ? undefined : json['last_found'],
    };
}

export function MonitEntityAssetDomainBlocklistToJSON(value?: MonitEntityAssetDomainBlocklist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domain': value.domain,
        'path': value.path,
        'root_domain': value.root_domain,
        'ip_addresses': value.ip_addresses,
        'source_list_name': value.source_list_name,
        'category': value.category,
        'subcategory': value.subcategory,
        'created': value.created,
        'last_found': value.last_found,
    };
}

